import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getGameCoinMap } from "@/utils/dictionary";
export default {
  name: "AppSelect",
  props: {
    value: {
      default: 0
    },
    data_no_all: {
      default: 1
    },
    multiple: {
      default: false
    }
  },
  data: function data() {
    return {
      coin_type: this.value,
      coinList: {}
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.coin_type = val;
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = {
              data_no_all: _this.data_no_all
            };
            _context.next = 3;
            return getGameCoinMap();
          case 3:
            _this.coinList = _context.sent;
            if (_this.app_id != "") {
              _this.selectApp();
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    selectApp: function selectApp() {
      this.$emit("input", this.coin_type);
      this.$emit("change", this.coin_type);
    }
  }
};